import { ScrollView } from "../ScrollView";
import { IScrollViewLimit } from "./IScrollViewLimit.js";
import { ScrollViewLimit } from "./ScrollViewLimit.js";

export class ScrollViewLimitAuto implements IScrollViewLimit {
    public getMinX(view: ScrollView, scale: number = view.scale): number {
        var rw = view.contentWidth * scale;
        if (rw < view.width) {
            return ScrollViewLimit.Center.getMinX(view, scale);
        }
        return ScrollViewLimit.Cover.getMinX(view, scale);
    }

    public getMaxX(view: ScrollView, scale: number = view.scale): number {
        var rw = view.contentWidth * scale;
        if (rw < view.width) {
            return ScrollViewLimit.Center.getMaxX(view, scale);
        }
        return ScrollViewLimit.Cover.getMaxX(view, scale);
    }

    public getMinY(view: ScrollView, scale: number = view.scale): number {
        var rh = view.contentHeight * scale;
        if (rh < view.height) {
            return ScrollViewLimit.Center.getMinY(view, scale);
        }
        return ScrollViewLimit.Cover.getMinY(view, scale);
    }

    public getMaxY(view: ScrollView, scale: number = view.scale): number {
        var rh = view.contentHeight * scale;
        if (rh < view.height) {
            return ScrollViewLimit.Center.getMaxY(view, scale);
        }
        return ScrollViewLimit.Cover.getMaxY(view, scale);
    }
}